/*
  초기화면 ( home )
    OWL Start

*/
import React from "react";
import "./Home.css";
import LoaderButton from "../components/LoaderButton";
import NotificationComponent from "../components/NotificationComponent"; // NotificationComponent 임포트

import { Auth } from 'aws-amplify';
import config from '../config';

export default function Home(props) {

  function handleClick(e) {
    e.preventDefault();
    // 생성정보 확인하여 팝업 띄우기.
    Auth.currentAuthenticatedUser({
      bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).then( user => {

      const newYn = localStorage.getItem('new_yn');
      console.log("new_Yn : "  + newYn); // 사용

      var accessToken = user.signInUserSession.getAccessToken().getJwtToken();
      var url = (newYn === "Y") ? config.owl_callback.starterNew : config.owl_callback.starter;
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'accessToken';
      input.value = accessToken;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
      // window.open(url, '_blank', 'noopener,noreferrer');
        // "レセプトチェッカーＬＳ Beta Server",
        // 'scrollbars=no,status=no,titlebar=no,toolbar=no,status=no,resizable=yes,menubar=no,location=no,width=1024, height=700'
      // );

    }).catch( err => {
      console.log("catch( err => {");
      console.log(err);
      //alert ("ログインをお願いします。") ;
      props.history.push("/login");
     });

  }

  return (
    <div className="Home">
      <div className="lander">
        <h1>医療機関向けクラウド版(Beta)</h1>
          <LoaderButton block onClick={handleClick} bsSize="large" >
             Ｓｔａｒｔ
          </LoaderButton>

          <NotificationComponent /> {/* NotificationComponent 사용 */}

{/* -- 2024.08.05 적용 */ }          
{/* --2024.08.19 적용해제 
          <div class="wrap">
          <div class="box">
            <div class="in">
            <h4><b>サポートデスク夏季休業期間について</b></h4>
            <h4>平素より、レセプトチェッカーLSクラウド版を<br/>ご愛顧いただき誠にありがとうございます。</h4>
            <h4>サポートデスクの夏季休業期間をお知らせします。</h4>
            <h4 class="noti_color">2024年8月10日（土）～8月18日（日）<br/></h4>

            <h4>8月19日（月）より通常営業いたします。<br/>
            メールやレセプトチェッカーの問合せ機能からの問合せの回答は19日(月)から対応いたします。<br/><br/>
            何卒よろしくお願いいたします。<br/>
            レセプトチェッカーサポートデスク</h4>
            </div>
          </div>
        </div>
  */}        
      </div>
    </div>
  );
}
